import React from 'react'

import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Popconfirm, Tooltip } from 'antd'

const DEFAULT_BUTTON_STYLE = { width: '34px', marginLeft: '2px', textAlign: 'center' }

export const ACTIONS = {
  ARCHIVE_SECTOR: 'archive_sector',
  CREATE: 'create',
  CREATE_ACT_TYPE: 'create_act_type',
  CREATE_ACT_TYPE_CATEGORY: 'create_act_type_category',
  CREATE_EC: 'create_external_contact',
  CREATE_SECTOR: 'create_sector',
  DELETE: 'delete',
  DELETE_ACT_TYPE_CATEGORY: 'delete_act_type_category',
  DELETE_EC: 'delete_external_contact',
  DISPLAY_ACT_CATEGORIES: 'display_act_categories',
  DISPLAY_ACT_TYPE_SECTIONS: 'display_act_type_sections',
  DISPLAY_INSTITUTION_SECTORS: 'display_institution_sectors',
  EDIT: 'edit',
  EDIT_ACT_TYPE: 'edit_act_type',
  EDIT_ACT_TYPE_CATEGORY: 'edit_act_type_category',
  EDIT_EC: 'edit_external_contact',
  EDIT_SECTOR: 'edit_sector',
  LINK_INSTITUTION_GROUP_SCHOOL: 'link_institution_group_school',
  LINK_INSTITUTION_SCHOOL: 'link_institution_school',
  SELECT: 'select',
  SWITCH_SECTOR: 'switch_sector',
  UNARCHIVE_SECTOR: 'unarchive_sector',
  UNLINK_INSTITUTION_GROUP_SCHOOL: 'unlink_institution_group_school',
  UNLINK_INSTITUTION_SCHOOL: 'unlink_institution_school'
}

export class Action {
  constructor ({ disabled = null, icon, placement = 'top', title, toRender = null, onClick }) {
    this.disabled = disabled
    this.icon = icon
    this.placement = placement
    this.title = title
    this.toRender = toRender
    this.onClick = onClick
  }

  render (data, index, translator) {
    return (
      <Tooltip key={`actions-${index}`} placement='top' title={translator(this.title)}>
        <Button
          disabled={typeof this.disabled === 'function' ? this.disabled(data) : !!this.disabled}
          type='primary'
          size='small'
          style={DEFAULT_BUTTON_STYLE}
          onClick={() => this.onClick(data)}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0px' }}>
            <FontAwesomeIcon icon={this.icon ?? faEdit} />
          </div>
        </Button>
      </Tooltip>
    )
  }
}

export class DeleteAction {
  constructor ({ icon = faTrash, placement = 'top', popconfirmTitle = 'Delete this data ?', title = 'Delete', toRender = null, onDelete }) {
    this.icon = icon
    this.placement = placement
    this.popconfirmTitle = popconfirmTitle
    this.title = title
    this.toRender = toRender
    this.onDelete = onDelete
  }

  render (data, index, translator) {
    return (
      <Tooltip key={`delete-action-${index}`} placement='top' title={translator(this.title)}>
        <Popconfirm
          placement='top'
          okType='danger'
          title={typeof this.popconfirmTitle === 'string' ? translator(this.popconfirmTitle) : this.popconfirmTitle}
          okText={translator('Yes')}
          cancelText={translator('Cancel')}
          onConfirm={() => this.onDelete(data)}
        >
          <Button type='danger' size='small' style={DEFAULT_BUTTON_STYLE}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <FontAwesomeIcon icon={this.icon} />
            </div>
          </Button>
        </Popconfirm>
      </Tooltip>
    )
  }
}

export class ExternalAction {
  constructor ({ Component, key, props = {}, title, onClick }) {
    this.Component = Component
    this.key = key
    this.props = props
    this.title = title
    this.onClick = onClick
  }
}
